<template>
  <div>
    <div class="w100 pb20 cl-f">
      <div class="fr pr10">
        <el-button v-if="appData" @click="$emit('click-collect', appData.isCollect)" :loading="collecting">
          <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
          {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
        </el-button>
      </div>
    </div>

    <div class="w100" v-loading="loading">
      <section v-if="pData">
        <p class="w100 font-16 pb10 bor-b blue">档案状态</p>
        <el-row class="w100 font-14" :gutter="10">
          <el-col class="pt10 pb10" :span="8">档案状态：{{ pData.dazt }}</el-col>
          <el-col class="pt10 pb10" :span="8">档案号：{{ pData.dah }}</el-col>
          <el-col class="pt10 pb10" :span="8">学号：{{ pData.xh }}</el-col>
          <el-col class="pt10 pb10" :span="8">姓名：{{ pData.xm }}</el-col>
          <el-col class="pt10 pb10" :span="8">院系：{{ pData.yx }}</el-col>
          <el-col class="pt10 pb10" :span="8">年级：{{ pData.nj }}</el-col>
          <el-col class="pt10 pb10" :span="8">专业：{{ pData.zy }}</el-col>
          <el-col class="pt10 pb10" :span="8">班级：{{ pData.bj }}</el-col>
        </el-row>

        <p class="w100 font-16 mt20 pb10 bor-b blue">档案材料</p>
        <el-table class="w100 mt20" :data="pData.dacl" stripe border height="300">
          <el-table-column prop="dacl" label="档案材料"></el-table-column>
          <el-table-column prop="jsr" label="接收人"></el-table-column>
          <el-table-column prop="jsrq" label="接收日期"></el-table-column>
          <el-table-column prop="bz" label="备注"></el-table-column>
        </el-table>

        <p class="w100 font-16 mt20 pb10 bor-b blue">档案接收信息</p>
        <el-row class="w100 font-14" :gutter="10">
          <el-col class="pt10 pb10" :span="8">接收人：{{ pData.jsr }}</el-col>
          <el-col class="pt10 pb10" :span="8">接收日期：{{ pData.jsrq }}</el-col>
          <el-col class="pt10 pb10" :span="8">接收方式：{{ pData.jsfs }}</el-col>
          <el-col class="pt10 pb10" :span="8">机要号：{{ pData.jyh }}</el-col>
          <el-col class="pt10 pb10" :span="16">投递单位：{{ pData.tddw }}</el-col>
          <el-col class="pt10 pb10" :span="16">投递单位地址：{{ pData.tddwdz }}</el-col>
          <el-col class="pt10 pb10" :span="8">投递人：{{ pData.tdr }}</el-col>
          <el-col class="pt10 pb10" :span="8">投递单位邮编：{{ pData.tddwyb }}</el-col>
          <el-col class="pt10 pb10" :span="8">投递单位电话：{{ pData.tddwdh }}</el-col>
          <el-col class="pt10 pb10" :span="16">投递单位邮箱：{{ pData.tddwyx }}</el-col>
          <el-col class="pt10 pb10" :span="24">备注：{{ pData.bz }}</el-col>
          <el-col class="pt10 pb10" :span="24"></el-col>
        </el-row>
      </section>
      <p class="w100 tx-c grey" v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "StudentArchives",
  components: {
    SiftComp
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {

      loading: false,
      error: "",

      pData: null
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let obj = {};
      obj.userId = this.userData.userId;

      this.loading = true;
      this.$http
        .post(
          this.$route.query.interfaceUrl + `/query`,
          this.$qs.stringify(obj)
        )
        .then(({ data }) => {
          if (data.resCode == 0 && data.resStatus == 0) {
            // console.log(data);
            this.pData = data.resData;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    clickRow(row, event, column) {
      // console.log(row);
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>
